import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (name) {
  return require('@/components/' + name + '.vue')
}
var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

export default new Router({

  mode: mode,
  base: '/eng/',

  routes: [
    { path: '/',  redirect: '/home'}, // Default
    { path: '/savethedate', name: 'savethedate', components:{main: load('Savethedate') } }, 
    { path: '/home', name: 'home', meta: { nav: true }, components:{main: load('Home') } }, 

    { path: '/progetti', name: 'progetti', meta: { nav: true }, components:{main: load('Progetti') } }, 
    { path: '/tipologia/:id/:tipologia', name: 'tipologia', meta: { nav: true }, components:{main: load('Tipologia') } }, 
    { path: '/tema/:id/:tema', name: 'tema', meta: { nav: true }, components:{main: load('Tema') } }, 
    
    { path: '/inside/:area/:page', name: 'inside', meta: { nav: true }, components:{main: load('Inside') } }, 

    { path: '*', components:{main: load('Home') }  } // Not found
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js